import { render } from "./AccordionVideoContainer.vue?vue&type=template&id=0f4772ee&scoped=true"
import script from "./AccordionVideoContainer.vue?vue&type=script&lang=js"
export * from "./AccordionVideoContainer.vue?vue&type=script&lang=js"

import "./AccordionVideoContainer.vue?vue&type=style&index=0&id=0f4772ee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4772ee"]])

export default __exports__